import React, { useState, useEffect } from 'react';
import { Edit2 } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import useAutosize from 'hooks/useAutosize';

const EmailComposition = ({
  i18n,
  isDisabled,
  previewing,
  givenAnswer,
  saveAnswer,
}) => {
  const [updatedSubject, setUpdatedSubject] = useState(
    givenAnswer ? givenAnswer.subject : '',
  );
  const [updatedBody, setUpdatedBody] = useState(
    givenAnswer ? givenAnswer.body : '',
  );
  const autosizeRef = useAutosize();
  const [updateTriggered, setUpdateTriggered] = useState(false);

  const handleSaveAnswer = () => {
    const answer = { subject: updatedSubject, body: updatedBody };
    saveAnswer(answer, true);
  };

  useEffect(() => {
    if (!previewing && updateTriggered) {
      handleSaveAnswer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedBody, updatedSubject, previewing]);

  const handleSubjectChange = e => {
    setUpdatedSubject(e.target.value);
    setUpdateTriggered(true);
  };

  const handleBodyChange = e => {
    setUpdatedBody(e.target.value);
    setUpdateTriggered(true);
  };

  return (
    <div>
      <Text className="d-f ai-c mb-16" variant={TEXT_VARIANTS.BODY_BOLD}>
        <Edit2 className="mr-4" size="1em" /> {i18n.email_composition.new}
      </Text>
      <div className="d-f fd-c">
        <Text className="mb-16" variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
          {i18n.email_practice.subject}
        </Text>
        <input
          className="ReplyContainer-input bg-gray-lightest bdrs-2 border border-gray-light mh-40 p-8 pl-12"
          onChange={handleSubjectChange}
          disabled={isDisabled}
          name="subject"
          value={previewing ? '' : updatedSubject}
          aria-label={i18n.email_practice.subject}
        />
        <Text className="mt-16" variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
          {i18n.email_composition.body}
        </Text>
        <textarea
          className="ReplyContainer-input h-100 pl-12 mt-16 p-8 bdrs-2 w-fill bg-gray-lightest border border-gray-light"
          onChange={handleBodyChange}
          disabled={isDisabled}
          rows="3"
          value={previewing ? '' : updatedBody}
          ref={autosizeRef}
          aria-label={i18n.email_composition.instructions}
        />
      </div>
    </div>
  );
};

export default EmailComposition;
